// app actions
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_APP_LAYOUT = 'SET_APP_LAYOUT';
export const SET_APP_PATH = 'SET_APP_PATH';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const INCREMENT_WIZARD_STEP = 'INCREMENT_WIZARD_STEP';
export const DECREMENT_WIZARD_STEP = 'DECREMENT_WIZARD_STEP';
export const RESET_WIZARD_STEP = 'RESET_WIZARD_STEP';
export const SET_CURRENT_TIME_ZONE = 'SET_CURRENT_TIME_ZONE';
export const SET_TIME_ZONES = 'SET_TIME_ZONES';

// current user actions
export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const USER_ETAG_CHANGED = 'USER_ETAG_CHANGED';
export const SET_LOGIN_2FA_CODE_DATA = 'SET_LOGIN_2FA_CODE_DATA';

// images actions
export const ADD_IMAGE_LINK = 'ADD_IMAGE_LINK';
export const SET_ATTACHMENT = 'SET_ATTACHMENT';
export const CLEAR_ATTACHMENT = 'CLEAR_ATTACHMENT';

// current account actions
export const SET_ACCOUNTS = 'SET_ACCOUNTS_LIST';
export const SET_IS_SHOWING_NOTIFICATION = 'SET_IS_SHOWING_NOTIFICATION';
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const ACCOUNT_SETTINGS_FAILED = 'ACCOUNT_SETTINGS_FAILED';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
export const UPDATE_ACCOUNT_TIMESTAMP = 'UPDATE_ACCOUNT_TIMESTAMP';
export const SET_API_KEYS = 'SET_API_KEYS';
export const SET_CURRENT_API_KEY = 'SET_CURRENT_API_KEY';
export const CLEAR_CURRENT_API_KEY = 'CLEAR_CURRENT_API_KEY';
export const SET_CREATED_API_KEY = 'SET_CREATED_API_KEY';
export const CLEAR_CREATED_API_KEY = 'CLEAR_CREATED_API_KEY';
export const SET_EXISTING_ACCOUNT = 'SET_EXISTING_ACCOUNT';

// entities actions
export const FETCH_START = 'FETCH_START';
export const FETCH_STOP = 'FETCH_STOP';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_RESET = 'FETCH_RESET';
export const ENTITY_UPDATED = 'ENTITY_UPDATED';
export const SET_VERIFICATION_METHOD = 'SET_VERIFICATION_METHOD';

//dialogs actions
export const ERROR_DIALOG_OPEN = 'ERROR_DIALOG_OPEN';
export const ERROR_DIALOG_CLOSE = 'ERROR_DIALOG_CLOSE';

//slates views
export const SET_SLATE_VIEWS_LIST = 'SET_SLATE_VIEWS_LIST';
export const SET_CURRENT_SLATE_VIEW = 'SET_CURRENT_SLATE_VIEW';
export const SET_CURRENT_SLATE_VIEW_WITHOUT_VIEW_LIST = 'SET_CURRENT_SLATE_VIEW_WITHOUT_VIEW_LIST';
export const SET_SLATES = 'SET_SLATES';
export const SET_SLATES_SEARCH_RESULTS = 'SET_SLATES_SEARCH_RESULTS';
export const CLEAR_SLATES = 'CLEAR_SLATES';
export const CLEAR_SLATE_VIEWS = 'CLEAR_SLATE_VIEWS';
export const SET_NEW_SLATE_VIEW_TYPE = 'SET_NEW_SLATE_VIEW_TYPE';
export const SET_SLATE_VIEW_SETTINGS = 'SET_SLATE_VIEW_SETTINGS';
export const CLEAR_SLATE_VIEW_SETTINGS = 'CLEAR_SLATE_VIEW_SETTINGS';
export const SET_SETTINGS_FIELDS = 'SET_SETTINGS_FIELDS';
export const CLEAR_SETTINGS_FIELDS = 'CLEAR_SETTINGS_FIELDS';
export const UPDATE_SETTINGS_FIELDS_FILTERS = 'UPDATE_SETTINGS_FIELDS_FILTERS';
export const CLEAN_SETTINGS_FIELDS_FILTERS = 'CLEAN_SETTINGS_FIELDS_FILTERS';
export const SET_SETTINGS_OPERATORS = 'SET_SETTINGS_OPERATORS';
export const REVERT_SETTINGS_OPERATORS = 'REVERT_SETTINGS_OPERATORS';
export const CONFIRM_SETTINGS_OPERATORS = 'CONFIRM_SETTINGS_OPERATORS';
export const OPEN_WARNING_SETTING_DIALOG = 'OPEN_WARNING_SETTING_DIALOG';
export const CLEAN_SNAPSHOT_PREVIOUS_VERSION = 'CLEAN_SNAPSHOT_PREVIOUS_VERSION';
export const CLEAR_SETTINGS_OPERATORS = 'CLEAR_SETTINGS_OPERATORS';
export const UPDATE_SLATE_PANE_STATE = 'UPDATE_SLATE_PANE_STATE';
export const UPDATE_SLATE_VIEW_FILTERS = 'UPDATE_SLATE_VIEW_FILTERS';
export const CLEAR_SLATE_VIEW_FILTERS = 'CLEAR_SLATE_VIEW_FILTERS';
export const SET_CURRENT_SLATE = 'SET_CURRENT_SLATE';
export const SET_RECORD_ENTRIES = 'SET_RECORD_ENTRIES';
export const CLEAR_RECORD_ENTRIES = 'CLEAR_RECORD_ENTRIES';
export const SET_HISTORY_ENTRIES = 'SET_HISTORY_ENTRIES';
export const CLEAR_HISTORY_ENTRIES = 'CLEAR_HISTORY_ENTRIES';
export const SET_RECORD_SLATE = 'SET_RECORD_SLATE';
export const CLEAR_RECORD_SLATE = 'CLEAR_RECORD_SLATE';
export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export const CLEAN_SLATE_VIEWS_AFTER_UPDATE_SETTINGS =
  'CLEAN_SLATE_VIEWS_AFTER_UPDATE_SETTINGS';

//jobs
export const SET_JOBS = 'SET_JOBS';
export const CLEAR_JOBS = 'CLEAR_JOBS';
export const SET_JOB_SETTINGS = 'SET_JOB_SETTINGS';
export const CLEAR_JOB_SETTINGS = 'CLEAR_JOB_SETTINGS';
export const SET_JOBS_TAB_UPDATE = 'SET_JOBS_TAB_UPDATE';

//map
export const UPDATE_MAP_TYPE = 'UPDATE_MAP_TYPE';

// theme
export const SET_THEME_MODE = 'SET_THEME_MODE';

//notifications
export const SET_FETCHING_INFO = 'SET_FETCHING_INFO';
export const CLEAR_FETCHING_TYPE = 'CLEAR_FETCHING_TYPE';
export const SET_ACTIVE_NOTIFICATION = 'SET_ACTIVE_NOTIFICATION';
export const SET_ACTIVE_NOTIFICATION_INFO = 'SET_ACTIVE_NOTIFICATION_INFO';
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const SET_LIST_OF_NOTIFICATIONS = 'SET_LIST_OF_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

// slate pane content lifecycle
export const SLATE_PANE_CONTENT_LOADED = 'SLATE_PANE_CONTENT_LOADED';
export const SLATE_PANE_CONTENT_CHANGED = 'SLATE_PANE_CONTENT_CHANGED';
export const SLATE_PANE_CONTENT_SAVED = 'SLATE_PANE_CONTENT_SAVED';

// help pane
export const UPDATE_HELP_PANE_STATE = 'UPDATE_HELP_PANE_STATE';

// custom modules
export const SET_ACTIVE_CUSTOM_MODULE = 'SET_ACTIVE_CUSTOM_MODULE';

// inspect
export const SET_INSPECTIONS = 'SET_INSPECTIONS';
export const SET_CURRENT_INSPECTION = 'SET_CURRENT_INSPECTION';
export const SET_INSPECTION_RECORDS = 'SET_INSPECTION_RECORDS';
export const CLEAR_INSPECTION_RECORDS = 'CLEAR_INSPECTION_RECORDS';
export const PATCH_INSPECTION_HISTORY_RECORD = 'PATCH_INSPECTION_HISTORY_RECORD';
export const SET_INSPECTION_SCHEDULED = 'SET_INSPECTION_SCHEDULED';
export const CLEAR_INSPECTION_SCHEDULED = 'CLEAR_INSPECTION_SCHEDULED';
export const SET_INSPECTION_PERFORMANCE = 'SET_INSPECTION_PERFORMANCE';
export const CLEAR_INSPECTION_PERFORMANCE = 'CLEAR_INSPECTION_PERFORMANCE';
export const CLEAR_INSPECT = 'CLEAR_INSPECT';
export const SET_INSPECTION_SETTINGS = 'SET_INSPECTION_SETTINGS';
export const CLEAR_INSPECTION_SETTINGS = 'CLEAR_INSPECTION_SETTINGS';
export const SET_INSPECT_SELECTION = 'SET_INSPECT_SELECTION';
export const SET_INSPECT_COLUMN_FILTER = 'SET_INSPECT_COLUMN_FILTER';
export const SET_INSPECT_COLUMNS = 'SET_INSPECT_COLUMNS';
export const CLEAR_INSPECT_COLUMN_FILTERS = 'CLEAR_INSPECT_COLUMN_FILTERS';
export const SET_INSPECT_SORT = 'SET_INSPECT_SORT';
export const SET_INSPECT_DATE_RANGE = 'SET_INSPECT_DATE_RANGE';
export const SET_INSPECT_SCHEDULED_COLUMN_FILTER = 'SET_INSPECT_SCHEDULED_COLUMN_FILTER';
export const CLEAR_INSPECT_SCHEDULED_COLUMN_FILTERS = 'CLEAR_INSPECT_SCHEDULED_COLUMN_FILTERS';
export const SET_INSPECT_SCHEDULED_SORT = 'SET_INSPECT_SCHEDULED_SORT';
export const SET_INSPECT_SCHEDULED_COLUMNS = 'SET_INSPECT_SCHEDULED_COLUMNS';
export const SET_INSPECT_PIVOT = 'SET_INSPECT_PIVOT';

// Chat session (SlateMate multi-turn)
export const CHAT_SESSION_INIT = 'CHAT_SESSION_INIT';
export const CHAT_SESSION_HYDRATE = 'CHAT_SESSION_HYDRATE';
export const CHAT_SESSION_SET_UUID = 'CHAT_SESSION_SET_UUID';
export const CHAT_SESSION_RECONCILED = 'CHAT_SESSION_RECONCILED';
export const CHAT_SESSION_CLEARED = 'CHAT_SESSION_CLEARED';

export const CHAT_MESSAGE_QUEUED = 'CHAT_MESSAGE_QUEUED';
export const CHAT_ASSISTANT_PLACEHOLDER_PUSHED = 'CHAT_ASSISTANT_PLACEHOLDER_PUSHED';
export const CHAT_USER_MESSAGE_UUID_ASSIGNED = 'CHAT_USER_MESSAGE_UUID_ASSIGNED';
export const CHAT_MESSAGE_APPEND_DELTA = 'CHAT_MESSAGE_APPEND_DELTA';
export const CHAT_MESSAGE_END = 'CHAT_MESSAGE_END';
export const CHAT_MESSAGE_INTERRUPTED = 'CHAT_MESSAGE_INTERRUPTED';
export const CHAT_MESSAGE_ERRORED = 'CHAT_MESSAGE_ERRORED';

export const CHAT_TOOL_START = 'CHAT_TOOL_START';
export const CHAT_TOOL_PROGRESS = 'CHAT_TOOL_PROGRESS';
export const CHAT_TOOL_END = 'CHAT_TOOL_END';

export const CHAT_STREAM_STARTED = 'CHAT_STREAM_STARTED';
export const CHAT_STREAM_ENDED = 'CHAT_STREAM_ENDED';
export const CHAT_STREAM_TAKING_A_WHILE = 'CHAT_STREAM_TAKING_A_WHILE';
export const CHAT_THINKING_LABEL_SET = 'CHAT_THINKING_LABEL_SET';
export const CHAT_THINKING_LABEL_CLEARED = 'CHAT_THINKING_LABEL_CLEARED';
export const CHAT_RECOVERY_STARTED = 'CHAT_RECOVERY_STARTED';
export const CHAT_RECOVERY_ENDED = 'CHAT_RECOVERY_ENDED';
export const CHAT_SERVER_DOCUMENT_COUNT_INCREMENTED = 'CHAT_SERVER_DOCUMENT_COUNT_INCREMENTED';

export const CHAT_PENDING_ATTACHMENT_ADDED = 'CHAT_PENDING_ATTACHMENT_ADDED';
export const CHAT_PENDING_ATTACHMENT_REMOVED = 'CHAT_PENDING_ATTACHMENT_REMOVED';
export const CHAT_PENDING_ATTACHMENTS_CLEARED = 'CHAT_PENDING_ATTACHMENTS_CLEARED';
